module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-5",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("FIVE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("9 APRIL 1979")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-5-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("hat evening Pamela telephones, and Rebecca tells her about the awkward encounter with Brian Sheridan, the most senior survivor from Ingrow Ales – the original name before she changed it to Keighley Beers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And he kept going on about Margaret Thatcher. I think he’ll have a breakdown if she becomes prime minister.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, he’s from the company you bought?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes, a couple of years back.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca had read that the failing brewery would be closing, with up to a dozen local redundancies. She was familiar with their most successful ale, Sailor’s Watch, but it was a snap decision to buy the company, based on emotion rather than business sense.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, what do you think I should do about Brian?” Rebecca says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“If you’re asking for advice, I’d give him the heave-ho. He won’t change. Certainly not overnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I know I should. It’s just he’s the same age as my father when he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You can’t make business decisions based on that, surely,” Pamela says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The doorbell rings. Rebecca walks towards it with the handset, the cord stretching like a ringlet of hair pulled taut from the scalp.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Have you got a visitor?” Pamela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca is looking through the distorting glass panel on the left of her front door at a tall blue blur on the other side. “It’s a policeman.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“At this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes. I’d better go.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They send a policeman round when one of your relatives has died in tragic circumstances. She knows they’re not brilliant at breaking the news. Sometimes they give you a lift to identify the body. Unless they’re doing house-to-house enquiries about something else. She releases the gold catch and opens the door.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Good evening, madam, I’ve come to speak to you about an extremely serious matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He’s looking her straight in the eye, not smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What are you doing here?” She tries not to sound too irritated.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Hoping that you’ll invite me in. I’m on a shift, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m not brilliant with surprises, Simon.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes, you once told me your least favourite word is "), _c('i', [_vm._v("impromptu")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He follows her inside, through to the living room, pleased with himself.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“At least take that stupid hat off, or you’ll damage my chandelier.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He does so, resting it on the back of the sofa with the zigzag pattern in seven shades of brown.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Now it looks like I’ve got a policeman hiding behind my settee. You don’t normally do this. What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“This is…” He smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Simon comes up to her and slides his hand underneath the front of her skirt, but she pushes him away, tells him to stop, offers instead to make him a cup of tea. The stress of the last few days must be coming out. She’s irritated too that she hasn’t seen him in months.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He stands at a respectful distance as she fills the silver kettle, unembarrassed by what’s just happened. She’s aware that he’s watching her closely in the way that he does. Tonight, this feels stifling, although usually she likes it, that sense of being protected, that he’s interested in every small detail of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What is it, Simon? Why are you looking at me like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Nothing, he says, then tells her that he finally saw "), _c('i', [_vm._v("The First Great Train Robbery")]), _vm._v(". It had this fantastic action sequence with Sean Connery standing on top of a train. He had to keep ducking under bridges to avoid being decapitated – it was very funny, he tells her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, I heard you saw my brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes, we went for a drink. He looks like you, doesn’t he? And I don’t think I knew he works for your company.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He’s our marketing manager.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He seems so young.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They go back into the living room with their teas. Rebecca has become self-conscious about the décor which, ever since her most recent visit to Eileen, feels crass and blundering. Although permanently on the breadline and too proud to accept handouts from Rebecca, Eileen throws second-hand furniture and furnishings together with effortless urban chic.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I have a meeting with Saatchi & Saatchi next week,” Rebecca says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Ha-ha, very funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I do. I’m going to get them to produce an advert for Yorkshire Television.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You’ll be going to London for that, I expect. No doubt you’ll seal the deal over margaritas in their swanky offices.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca laughs. “Actually, they’re sending two executives up by train and I’m meeting them at the station. They want to see the Keighley Beers office. It’s not like you to play the chippy Yorkshire man,” she adds.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He apologises. She’s always admired his ability to admit when he’s wrong, or stepped too far, a quality she associates with his unshakeable sense of self.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She asks about his work, and he tells her that he’s moving across to work on the Yorkshire Ripper case. “Just me and three hundred others.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, you should be doing that rather than coming here and shoving your hand into my knickers.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Theoretically,” he says, a smile surfacing again. “Although the investigation won’t collapse because I’ve sloped off for a few minutes. I’ll make up the time if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Maybe you can tell me this. How do they know it’s the same man? Like on Friday. How did they know?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He tends to batter his victims on the head with a hammer from behind when they’re least expecting it. And that causes terrible damage to the skull, of course, and would probably be enough to kill them on its own. But he finishes them off with a frenzy of stabbing, often revealing their torso by pulling up their clothes–”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“All right, Simon–”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And the last one, he penetrated her with a screwdriver, but I don’t think that’s typical.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That’s enough, for goodness’ sake. I don’t need all the details.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Well, you did ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“But you didn’t have to answer with so much enthusiasm.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He looks slightly hurt and she regrets saying it almost immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Is there anything wrong?” he asks. “You don’t seem yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’ve been thinking very seriously about our relationship,” Rebecca says. “I’m not finishing things now. But it’s only right to let you know that I’m looking for something more suitable.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3552d433","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-005.vue
// module id = 90
// module chunks = 0